import { featureCreditMockScenario } from '@/config/featureFlags';
import {
  buildUnlockMockTransportPayload,
  resolveUnlockMockScenario,
  UNLOCK_MOCK_SCENARIOS
} from '@/core/api/mocks/unlockMockData';

const NETWORK_DELAY_MS = 120;

const sleep = (ms = NETWORK_DELAY_MS) => new Promise((resolve) => setTimeout(resolve, ms));

const createTimeoutError = () => {
  const error = new Error('unlock mock timeout');
  error.code = 'ECONNABORTED';
  return error;
};

const unlockMockService = {
  async queryScopeUnlockState({ userId, imageId, originalHashId, presetStyleId, scopeType, scopeKey, scenarioId } = {}) {
    await sleep();

    const resolvedScenarioId = resolveUnlockMockScenario(scenarioId || featureCreditMockScenario);
    if (resolvedScenarioId === UNLOCK_MOCK_SCENARIOS.TIMEOUT) {
      throw createTimeoutError();
    }

    return buildUnlockMockTransportPayload({
      userId,
      imageId,
      originalHashId,
      presetStyleId,
      scopeType,
      scopeKey,
      scenarioId: resolvedScenarioId
    });
  },

  async queryImageUnlockState(params = {}) {
    return this.queryScopeUnlockState(params);
  }
};

export default unlockMockService;
